export enum UnderwritingStatus {
    Pending = 'pending',
    InProgress = 'in-progress',
    Blocked = 'blocked',
    Done = 'done',
    Failed = 'failed',
    Canceled = 'canceled',
}
